module.exports = __webpack_public_path__ + "img/bold-tick.1211a0df.svg";